import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const FEMAComplianceForForeignEntities = () => {
  const serviceData = {
    title: "FEMA / RBI Compliance for Foreign-Owned Entities",
    heading: "FEMA / RBI Compliance for Foreign-Owned Entities",
    image: subTopicImages["FEMA/RBI Compliance for Foreign-Owned Entities"],
    intro: "FEMA & Cross-Border Regulatory Compliance — Specialist Advisory",
    description: [
      "Foreign investment into India is regulated by FEMA and RBI guidelines, covering capital inflows, pricing norms, reporting, transfers, exits and repatriation. These matters are highly regulated and closely monitored — and any deviation may lead to penalties or regularisation actions.",
      "We specialise in supporting multinational subsidiaries, joint ventures, investment structures and cross-border groups in ensuring full compliance with FEMA regulations.",
    ],
    services: [
      {
        title: "FEMA / RBI Compliance Services",
        text: "Our services include:",
        list: [
          "advisory on sectoral caps & foreign investment routes",
          "investment structuring & policy interpretation",
          "FC-GPR, FC-TRS, FLA & other FEMA filings",
          "pricing compliance & valuation support",
          "reporting for capital infusion & share transfers",
          "downstream investment compliance",
          "ODI / overseas investment support",
          "documentation, records & transaction reviews",
          "FEMA audit & clarification support",
          "compounding advisory (where required)",
        ],
        extraInfo: "",
      },
    ],
    benefitsIntro: "Who we support",
    benefits: [
      "foreign-owned Indian subsidiaries",
      "Indian companies with foreign shareholders",
      "cross-border investment vehicles",
      "M&A and investment transactions",
    ],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default FEMAComplianceForForeignEntities;
